import { blue, green, red } from '@material-ui/core/colors';

export const PAINT_ITEMS_CONFIG = [
  { key: 'blue', color: blue[500] },
  { key: 'red', color: red[500] },
  { key: 'green', color: green[500] },
  { key: 'violet', color: '#c017afff' },
  { key: 'brown', color: '#c45519ff' },
  { key: 'royalblue', color: '#19668dff' },
  { key: 'orange', color: '#ffc107' },
  { key: 'pink', color: '#e91e63' },
  { key: 'purple', color: '#8e44ad' },
  { key: 'indigo', color: '#3f51b5' },
  { key: 'cyan', color: '#00bcd4' },
  { key: 'teal', color: '#009688' },
  { key: 'lime', color: '#8bc34a' },
  { key: 'gold', color: '#d4af37' },
  { key: 'coral', color: '#ff6f61' },
  { key: 'turquoise', color: '#40e0d0' },
  { key: 'gray', color: '#607d8b' },
];

export const SOS_AREA_REQUIRED_BRAND = { defaultColor: PAINT_ITEMS_CONFIG[0].key, brandId: 1 };

export const getOrderedPaintItems = (brandOptions, colorOptions) => {
  const visiblePaintItems = PAINT_ITEMS_CONFIG.slice(
    0,
    brandOptions.filter((brandOption) => brandOption.value !== 0).length,
  );
  const requiredPaintItem = brandOptions.some(
    (brandOption) => brandOption.value === SOS_AREA_REQUIRED_BRAND.brandId,
  ) && PAINT_ITEMS_CONFIG.find(
    (item) => colorOptions[item.key] === SOS_AREA_REQUIRED_BRAND.brandId,
  );

  return requiredPaintItem
    ? [
      requiredPaintItem,
      ...visiblePaintItems.filter((item) => item.key !== requiredPaintItem.key),
    ]
    : visiblePaintItems;
};

export const getPhotosMissingRequiredBrand = (
  images,
  vectorsByImage,
  { getScopeKey, resolveBrand },
) => images.reduce((photosByScope, image, imageIndex) => {
  const vectors = vectorsByImage[image.id] || [];
  const scopeKeys = [...new Set(vectors.map((vector) => getScopeKey(vector.subCategoryId)))];

  return scopeKeys
    .filter((scopeKey) => !vectors.some((vector) => (
      getScopeKey(vector.subCategoryId) === scopeKey
      && resolveBrand(image.id, vector) === SOS_AREA_REQUIRED_BRAND.brandId
    )))
    .reduce((photos, scopeKey) => ({
      ...photos,
      [scopeKey]: [...(photos[scopeKey] || []), imageIndex + 1],
    }), photosByScope);
}, {});

export const formatPhotosMissingRequiredBrand = (
  photosByScope,
  {
    t, language, scopeOrder, getScopeName,
  },
) => {
  const listFormat = new Intl.ListFormat(language, { style: 'long', type: 'conjunction' });
  const getScopeRank = (scopeKey) => {
    const rank = scopeOrder.indexOf(scopeKey);
    return rank === -1 ? scopeOrder.length : rank;
  };

  return Object.keys(photosByScope)
    .sort((a, b) => getScopeRank(a) - getScopeRank(b))
    .map((scopeKey) => t('teleaudit.confirmModal.missingRequiredBrandDetail', {
      count: photosByScope[scopeKey].length,
      category: getScopeName(scopeKey),
      photos: listFormat.format(photosByScope[scopeKey].map(String)),
    }))
    .join(t('teleaudit.confirmModal.missingRequiredBrandDetailSeparator'));
};

export const getAvailableBrandOptions = (
  brandOptions,
  colorOptions,
  colorName,
  selectedOption,
) => brandOptions.filter((brandOption) => (
  brandOption.value === 0
  || brandOption.value === selectedOption
  || !Object.entries(colorOptions).some(([selectedColor, selectedBrand]) => (
    selectedColor !== colorName && selectedBrand === brandOption.value
  ))
));
